import { Fragment } from "react";

export const CreditCardNumber = (props) => {
  const { cardInfo, setCardInfo } = props;
  return (
    <Fragment>
      <div className="mb-3">
        <label htmlFor="cardNumber" className="form-label">
          <strong>Credit Card Number</strong>
        </label>
        <input
          type="text"
          className="form-control"
          id="cardNumber"
          placeholder="Enter your credit card number"
          value={cardInfo.cardNumber}
          onChange={(e) => {
            const input = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
            if (input.length <= 16) {
              const formatted = input
                .replace(/(\d{4})/g, "$1 ") // Group into sets of 4 digits
                .trim(); // Remove trailing spaces
              setCardInfo((prev) => ({ ...prev, cardNumber: formatted }));

              // Detect card type
              const firstDigit = input.charAt(0);
              let cardType = "";
              if (firstDigit === "4") cardType = "Visa";
              else if (firstDigit === "5") cardType = "MasterCard";
              else if (firstDigit === "3") cardType = "American Express";
              else if (firstDigit === "6") cardType = "Discover";
              console.log("Detected Card Type:", cardType); // For visual card type detection
            }
          }}
          required
        />
        <small className="text-muted">Format: XXXX XXXX XXXX XXXX</small>
      </div>

      <div className="mb-3">
        <label htmlFor="cardExpiry" className="form-label">
          <strong>Expiry Date (MM/YY)</strong>
        </label>
        <input
          type="text"
          className="form-control"
          id="cardExpiry"
          placeholder="MM/YY"
          value={cardInfo.cardExpiry}
          onChange={(e) => {
            const input = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
            if (input.length <= 4) {
              const formatted = input.replace(/(\d{2})(\d{1,2})?/, "$1/$2"); // Add slash after MM
              setCardInfo((prev) => ({ ...prev, cardExpiry: formatted }));
            }
          }}
          required
        />
        <small className="text-muted">Format: MM/YY</small>
      </div>

      <div className="mb-3">
        <label htmlFor="cardCVC" className="form-label">
          <strong>CVV</strong>
        </label>
        <input
          type="text"
          className="form-control"
          id="cardCVC"
          placeholder="Enter your CVV"
          value={cardInfo.cardCVC}
          onChange={(e) => {
            const input = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
            if (input.length <= 4) {
              setCardInfo((prev) => ({ ...prev, cardCVC: input })); // CVV max length: 4
            }
          }}
          required
        />
        <small className="text-muted">Format: 3 or 4 digits</small>
      </div>
    </Fragment>
  );
};
